import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { QuoteActions, QuoteState } from '@nibtravel/shared/data-access/quote';
import { IRadio, IRadioGroup } from '@nibtravel/shared/ui/forms/radio-group';
import { IPolicyHoldersInput } from '@nibtravel/shared/util/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AgeAmbiguitySelector } from './age-ambiguity.selector';

declare type RadioConfig = {
  config: IRadioGroup;
  id: string | undefined;
};

@Component({
  selector: 'nibtravel-age-ambiguity',
  templateUrl: './age-ambiguity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgeAmbiguityComponent implements OnInit {
  policyHolders$!: Observable<IPolicyHoldersInput[]>;
  radios$!: Observable<RadioConfig[]>;

  @Select(AgeAmbiguitySelector.maxDependentAge)
  maxDependentAge$!: Observable<number>;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.radios$ = this.store.selectOnce(QuoteState.getPolicyHolders).pipe(
      map((data) => data.filter((ph) => ph.isAmbiguous)),
      map((data) => this.setupRadios(data))
    );
  }

  setupRadios(policyHolders: IPolicyHoldersInput[]): RadioConfig[] {
    return policyHolders.map((ph, i) => ({
      config: this.buildConfig(ph, i),
      id: ph.guid,
    }));
  }

  buildConfig(ph: IPolicyHoldersInput, index: number): IRadioGroup {
    // TODO: Need to apply translation for this
    return {
      hostId: `age-ambiguity${index}`,
      label: `Is the ${ph.age} year old a dependent?`,
      groupName: `ageAmbiguity${index}`,
      data: [
        this.getIndividualRadio(true, index),
        this.getIndividualRadio(false, index),
      ],
    };
  }

  getIndividualRadio(value: boolean, index: number): IRadio {
    // TODO: Need to apply translation for this
    return {
      inputId: `age-id-${value}-${index}`,
      name: `age-name-${value}-${index}`,
      label: value ? 'Yes' : 'No',
      labelId: `age-label-id-${value}-${index}`,
      value: value,
    };
  }

  onCheck(value: string, guid: string): void {
    this.store.dispatch(new QuoteActions.UpdateAmbiguity(value, guid));
  }
}
